export default new function googleMap($) {
  let infowindow;

  this.init = () => {
    this.modifyDOM();
    this.addEvents();

    window.googleMapsInitializer = this.helpers.initializeMap.bind(this);
    $.getScript('//maps.googleapis.com/maps/api/js?v=3.exp&key=' + window.REVENT_OPTIONS.GOOGLE_MAPS_KEY + '&libraries=geometry,places&callback=googleMapsInitializer');
  };

  this.modifyDOM = () => {
  };

  this.addEvents = () => {
    $(document).on('reInitGmaps', this.helpers.initializeMap.bind(this));
  };

  this.eventHandlers = {
  };

  this.helpers = {
    initializeMap() {
      const _this = this;
      const defaultOpts = {
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        minZoom: 2
      };

      $('.google-map').each(function() {
        if (!$(this).is(':visible')) {
          return;
        }

        if ($(this).hasClass('initialized')) {
          return;
        }

        const $markers = $(this).find('.marker');
        const opts = {};

        // .thumbnail also hides 'Google' image with css
        if ($(this).hasClass('thumbnail')) {
          opts.zoomControl = false;
        }

        const map = new window.google.maps.Map($(this)[0], $.extend(defaultOpts, opts));

        map.markers = [];

        $markers.each(function() {
          const lat = $(this).data('lat');
          const lng = $(this).data('lng');
          const large = $(this).data('large');
          if (lat && lng) {
            _this.helpers.addMarker(map, lat, lng, $(this).html(), large);
          }
        });

        _this.helpers.centerMap(map);
        // _this.helpers.styleMap(map);
        $(this).addClass('initialized');

        $(this).siblings('.module__action, .find-distributor__action').click(function() {
          const $btn = $(this).find('a');
          $btn.addClass('active');

          navigator.geolocation.getCurrentPosition(function(position) {
            const latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            map.setCenter(latlng);
            $btn.removeClass('active');
          });
        });
      });
    },

    addMarker(map, lat, lng, markerContent, large) {
      const position = new window.google.maps.LatLng(lat, lng);
      const icon = large ? '/content/themes/revent/dist/images/jw-marker-large.png' : '/content/themes/revent/dist/images/jw-marker-2.png';
      const zIndex = large ? 1000 : 999;
      const marker = new window.google.maps.Marker({
        position,
        map,
        icon,
        zIndex
      });

      map.markers.push(marker);

      // if marker contains HTML, add it to an infoWindow
      if (markerContent) {
        window.google.maps.event.addListener(marker, 'click', () => {
          if (infowindow) {
            infowindow.close();
          }

          infowindow = new window.google.maps.InfoWindow({
            content: markerContent
          });

          infowindow.open(map, marker);
        });
      }
    },

    centerMap(map) {
      const bounds = new window.google.maps.LatLngBounds();

      $.each(map.markers, (i, marker) => {
        const latlng = new window.google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
      });

      if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(14);
      } else {
        map.fitBounds(bounds);
      }
    },

    styleMap(map) {
      const styles = [
        {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry',
          'stylers': [
            {
                'color': '#f7f1df'
            }
          ]
        },
        {
          'featureType': 'landscape.natural',
          'elementType': 'geometry',
          'stylers': [
            {
                'color': '#d0e3b4'
            }
          ]
        },
        {
          'featureType': 'landscape.natural.terrain',
          'elementType': 'geometry',
          'stylers': [
            {
                'visibility': 'off'
            }
          ]
        },

        {
          'featureType': 'poi.medical',
          'elementType': 'geometry',
          'stylers': [
            {
                'color': '#fbd3da'
            }
          ]
        },
        {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [
            {
                'color': '#bde6ab'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
                'visibility': 'off'
            }
          ]
        },

        {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [
            {
                'color': '#ffe15f'
            }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
                'color': '#efd151'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'geometry.fill',
          'stylers': [
            {
                'color': '#ffffff'
            }
          ]
        },
        {
          'featureType': 'road.local',
          'elementType': 'geometry.fill',
          'stylers': [
            {
                'color': 'black'
            }
          ]
        },
        {
          'featureType': 'transit.station.airport',
          'elementType': 'geometry.fill',
          'stylers': [
            {
                'color': '#cfb2db'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
                'color': '#a2daf2'
            }
          ]
        }
      ];

      const styledMap = new window.google.maps.StyledMapType(styles, { name: 'Styled Map' });

      map.mapTypes.set('map_style', styledMap);
      map.setMapTypeId('map_style');
    }
  };

  return this.init;
}(jQuery);
